/* eslint-disable react-hooks/rules-of-hooks */
import { ColumnDef } from '@tanstack/table-core';
import { useAppDispatch } from 'src/hooks';
import {
    Grid,
    Tooltip
} from '@mui/material';
import { Header, TableComponent } from '../../../../pricing-simulator/types/generic-table.model';
import { handleVisibilityOfComments } from '../../../../planner/components/drawer/drawer-slice';

export default function getHeaderForLegendFlag(
    columnData: Header,
    componentType: TableComponent
) {
    const subHeader: ColumnDef<{
        [key: string]: number | string | { [key: string]: string }[];
    }> = {
        id:
            columnData.parent.parent_field !== ''
                ? columnData.parent.parent_field
                : columnData.parent.order.toString(),
        meta: {
            className: 'legend-col last'
        },
        // eslint-disable-next-line react/no-unescaped-entities
        header: (props) => <div />,
        cell: ({ row, getValue }) => {
            const appDispatch = useAppDispatch();
            const dataForRow = [];
            columnData.children.forEach((colData) => {
                if (row.original[colData.parent.parent_field] === 1) {
                    dataForRow.push({
                        [colData.parent.parent_field]:
                            row.original[colData.parent.parent_field],
                        color: colData.parent.fill_color
                    });
                }
            });

            const onFlagClick = (rowDetails: any) => {
                appDispatch(
                    handleVisibilityOfComments({ rowDetails: rowDetails.original })
                );
            };

            return (
                dataForRow.length > 0 && (
                    <Tooltip
                        title={
                            componentType === 'INNOVATION'
                                ? ''
                                : 'Click here to see the comments'
                        }
                        arrow
                        placement='right'
                    >
                        <div style={{ height: '100%', width: '8px', padding: '0' }}>
                            <Grid
                                container
                                alignItems='center'
                                flexDirection='column'
                                style={{ height: '100%' }}
                            >
                                {dataForRow.map((colData, index) => (
                                    // eslint-disable-next-line prefer-template
                                    <Grid key="grid_container" item style={{ height: 100 / dataForRow.length + '%' }}>
                                        <div
                                            onClick={() => onFlagClick(row)}
                                            onKeyDown={(e: { key: string; }) => {
                                                if (e.key == 'Enter' || e.key == ' ') {
                                                    onFlagClick(row)
                                                }
                                            }}
                                            style={{
                                                background: colData.color,
                                                opacity: row.depth === 0 ? '1' : '0.5',
                                                width: '8px',
                                                height: '100%'
                                            }}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                    </Tooltip>
                )
            );
        }
    };
    return subHeader;
};